import { connect } from 'react-redux';

import ErrorPage from 'components/pages/ErrorPage';

const mapStateToProps = () => ({

});

const mapDispatchToProps = () => ({

});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorPage);
